<template>
  <section>
    <h2>Prévention</h2>
    <div
      class="d-flex align-items-center justify-content-start my-4 row no-gutters"
    >
      <!-- Geste et Posture -->
      <div
        class="col-3 col-sm-2 order-1 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalGestePosture = !modalGestePosture"
          type="button"
          class="btn btn-secondary btn_repertoire"
        >
          <font-awesome-icon icon="people-carry" size="2x" />
        </button>

        <span class="text-secondary span_repertoire text-wrap"
          >Geste et posture</span
        >
        <b-modal
          v-model="modalGestePosture"
          centered
          hide-footer
          scrollable
          title="Geste et posture"
        >
          <ul class="list-group">
            <li class="list-group-item text-center">
              <span @click="modalPdfGestePosture = !modalPdfGestePosture"
                >Manutention et mal de dos</span
              >
            </li>
            <b-modal
              v-model="modalPdfGestePosture"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Manutention et mal de dos"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/1-fiche%20geste%20et%20posture.pdf&embedded=true"
              ></iframe>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalVideoGestePosture = !modalVideoGestePosture"
                >La manutention manuelle</span
              >
            </li>

            <b-modal
              v-model="modalVideoGestePosture"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="La manutention manuelle"
              @close="CloseModal()"
            >
              <video width="100%" height="100%" controls ref="video">
                <source
                  src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/15083%20-%20VDEF%20-%20RH%20ManutManuV2A1.mp4"
                  type="video/mp4"
                />
              </video>
            </b-modal>
          </ul>
        </b-modal>
      </div>

      <!-- Soulever une charge -->
      <div
        class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalCharge = !modalCharge"
          type="button"
          class="btn btn-dark btn_repertoire"
        >
          <font-awesome-icon icon="weight-hanging" size="2x" />
        </button>
        <span class="text-dark span_repertoire text-wrap"
          >Soulever une charge</span
        >
        <b-modal
          v-model="modalCharge"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Soulever une charge"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/2-soulever%20une%20charge.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Relaxation dos -->
      <div
        class="col-3 col-sm-2 order-3 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalDos = !modalDos"
          type="button"
          class="btn btn-warning btn_repertoire"
        >
          <font-awesome-icon icon="hiking" size="2x" />
        </button>
        <span class="text-warning span_repertoire text-wrap"
          >Relaxation du dos</span
        >
        <b-modal
          v-model="modalDos"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Relaxation du dos"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/3-relaxation%20dos.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Secourisme  -->
      <div
        class="col-3 col-sm-2 order-4 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalSecourisme = !modalSecourisme"
          type="button"
          class="btn btn-primary btn_repertoire"
          disabled
        >
          <font-awesome-icon icon="user-md" size="2x" />
        </button>
        <span class="text-primary span_repertoire text-wrap">Secourisme</span>
        <b-modal
          v-model="modalSecourisme"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Secourisme"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/4-fiche%20secourisme.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>
      <!-- Incendie -->
      <div
        class="col-3 col-sm-2 order-5 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalIncendie = !modalIncendie"
          type="button"
          class="btn btn-danger btn_repertoire"
        >
          <font-awesome-icon icon="fire" size="2x" />
        </button>
        <span class="text-danger span_repertoire">Incendie</span>
        <b-modal
          v-model="modalIncendie"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Incendie"
        >
          <div class="container-fluid text-center">
            <img
              src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/5-en%20cas%20d'incendie.jpg"
              class="img-fluid"
              alt="Sécurité Incendie"
            />
          </div>
        </b-modal>
      </div>

      <!-- Extincteur -->
      <div
        class="col-3 col-sm-2 order-6 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalExtincteur = !modalExtincteur"
          type="button"
          class="btn btn-info btn_repertoire"
        >
          <font-awesome-icon icon="fire-extinguisher" size="2x" />
        </button>
        <span class="text-info span_repertoire">Extincteur</span>
        <b-modal
          v-model="modalExtincteur"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Extincteur"
        >
          <div class="container-fluid text-center">
            <img
              src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/6-extincteur.jpg"
              class="img-fluid"
              alt="Extincteur"
            />
          </div>
        </b-modal>
      </div>
      <!-- Livret -->
      <div
        class="col-3 col-sm-2 order-7 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalInformation = !modalInformation"
          type="button"
          class="btn btn-success btn_repertoire"
        >
          <font-awesome-icon icon="book-open" size="2x" />
        </button>
        <span class="text-success span_repertoire">Information</span>
        <b-modal
          v-model="modalInformation"
          centered
          hide-footer
          scrollable
          title="Information"
        >
          <ul class="list-group">
            <li class="list-group-item text-center">
              <span @click="modalLivretAccueil = !modalLivretAccueil"
                >Livret d'accueil</span
              >
            </li>
            <b-modal
              v-model="modalLivretAccueil"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Livret d'accueil"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/7-a%20livret-accueil.pdf&embedded=true"
              ></iframe>
            </b-modal>

            <li class="list-group-item text-center">
              <span
                @click="
                  modalLivretAccueilInterimaire = !modalLivretAccueilInterimaire
                "
                >Livret d'accueil intérimaire</span
              >
            </li>
            <b-modal
              v-model="modalLivretAccueilInterimaire"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Livret d'accueil intérimaire"
            >
              <iframe
                class="modalPdf"
                src="//v.calameo.com/?bkcode=0039239128b2e0b84aace"
                allowfullscreen
              ></iframe>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalPlan = !modalPlan">Plan</span>
            </li>
            <b-modal
              v-model="modalPlan"
              size="xl"
              centered
              hide-footer
              scrollable
              title="Plan"
              content-class="modalSize"
            >
              <div class="container-fluid text-center">
                <img
                  src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/7-b%20plan.jpg"
                  class="img-fluid"
                  alt="Plan"
                />
              </div>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalPosteAtelier = !modalPosteAtelier"
                >Poste de travail Atelier</span
              >
            </li>
            <b-modal
              v-model="modalPosteAtelier"
              size="xl"
              centered
              hide-footer
              scrollable
              title="Poste de travail Atelier"
              content-class="modalSize"
            >
              <div class="container-fluid text-center">
                <img
                  src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/poste_de_travail.jpg"
                  class="img-fluid"
                  alt="Poste de travail Atelier"
                />
              </div>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalPosteBureau = !modalPosteBureau"
                >Poste de travail Bureau</span
              >
            </li>
            <b-modal
              v-model="modalPosteBureau"
              size="xl"
              centered
              hide-footer
              scrollable
              title="Poste de travail Bureau"
              content-class="modalSize"
            >
              <div class="container-fluid text-center">
                <img
                  src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/poste%20de%20travail.jpg"
                  class="img-fluid"
                  alt="Poste de travail Bureau"
                />
              </div>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalPanneauSecu = !modalPanneauSecu"
                >Panneau sécurité</span
              >
            </li>
            <b-modal
              v-model="modalPanneauSecu"
              size="xl"
              centered
              hide-footer
              scrollable
              title="Panneau sécurité"
              content-class="modalSize"
            >
              <div class="container-fluid text-center">
                <img
                  src="https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/pr%c3%a9vention/panneau%20secu.jpg"
                  class="img-fluid"
                  alt="Panneau sécurité"
                />
              </div>
            </b-modal>
          </ul>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      modalInformation: false,
      modalLivretAccueil: false,
      modalLivretAccueilInterimaire: false,
      modalPlan: false,
      modalPosteAtelier: false,
      modalPosteBureau: false,
      modalGestePosture: false,
      modalPanneauSecu: false,
      modalPdfGestePosture: false,
      modalVideoGestePosture: false,
      modalCharge: false,
      modalDos: false,
      modalSecourisme: false,
      modalIncendie: false,
      modalExtincteur: false
    };
  },
  methods: {
    // Bouton fermeture Modal document
    CloseModal() {
      // Pour mettre pause sur la video quand modal se ferme
      if (this.$refs.video != undefined) {
        let video = this.$refs.video;
        video.pause();
        return;
      }
      if (this.$refs.video1 != []) {
        if (this.$refs.video1 != undefined) {
          let video1 = this.$refs.video1;
          if (video1.length != 0) {
            video1[0].pause();
          }
        }
      }
    }
  }
};
</script>
